const t2 = {
    title: 'Məktəblilərin İntellekt Liqası',
    desc: 'Nə? Harada? Nə zaman? oyunu üzrə məktəbli liqası',
    slug: 'dersevi'
  };
  export default t2;
  